import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Migrated from Nemo library https://github.com/pearson-englishlanguagelearning/nemo-component-library/tree/main/packages/core-library/src/components/Feedback/alert/alert-standalone/v1
import { useCallback, useEffect, useRef, useState } from 'react';
import { NIcon } from '../NIcon/NIcon';
import NTypography from '../NTypography/NTypography';
import './NAlertStandalone.css';
/**
 * Standalone alerts provide timely and contextual information to users,
 * guiding them through specific situations like successes, warnings, errors, or informational updates.
 */
export const NAlertStandalone = ({ heading, type, showAlert = false, dismissible = false, actionText, onAlertClosed, onActionClick, children, className, style }) => {
    const [computedDir, setComputedDir] = useState('ltr');
    const alertRef = useRef(null);
    const closeButtonRef = useRef(null);
    const actionButtonRef = useRef(null);
    // Icon mapping based on alert type
    const iconMapping = {
        success: 'check-stroke',
        info: 'info-stroke',
        error: 'cross-stroke',
        warning: 'warning-stroke'
    };
    /**
     * Determines the read direction based on the computed CSS direction
     */
    const checkReadDirection = useCallback(() => {
        if (alertRef.current) {
            const computedStyle = window.getComputedStyle(alertRef.current);
            setComputedDir(computedStyle.direction);
        }
    }, []);
    /**
     * Handles closing the alert
     */
    const closeAlert = useCallback(() => {
        onAlertClosed?.();
    }, [onAlertClosed]);
    /**
     * Handles action button click
     */
    const handleActionClick = useCallback(() => {
        onActionClick?.();
    }, [onActionClick]);
    /**
     * Check read direction on mount
     */
    useEffect(() => {
        checkReadDirection();
    }, [checkReadDirection]);
    const alertClasses = [
        'n-alert-standalone',
        `n-alert-standalone-${type}`,
        `n-alert-standalone-${computedDir}`,
        showAlert ? 'n-alert-standalone-visible' : '',
        className || ''
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("div", { ref: alertRef, className: alertClasses, style: style, role: 'dialog', "aria-labelledby": 'alert-heading', "aria-describedby": 'alert-description', "aria-live": 'polite', "aria-atomic": true, children: [_jsxs("div", { className: 'n-alert-standalone-content', children: [_jsx("span", { className: 'n-alert-standalone-icon', children: _jsx(NIcon, { name: iconMapping[type], size: 'md' }) }), _jsxs("span", { children: [heading && (_jsx("span", { id: 'alert-heading', children: _jsx(NTypography, { variant: 'b2-strong', children: heading }) })), _jsx("span", { id: 'alert-description', children: _jsx(NTypography, { variant: 'b2', noMargin: true, children: children }) }), actionText && (_jsx("button", { className: 'n-alert-standalone-action', onClick: handleActionClick, ref: actionButtonRef, children: _jsx(NTypography, { variant: 'b2-strong', noMargin: true, children: actionText }) }))] })] }), _jsx("span", { className: 'n-alert-standalone-content', children: dismissible && (_jsx("button", { className: 'n-alert-standalone-close-icon', onClick: closeAlert, "aria-label": 'Close', ref: closeButtonRef, children: _jsx(NIcon, { name: 'cross-circle-stroke', size: 'md' }) })) })] }));
};
//# sourceMappingURL=NAlertStandalone.js.map